import { SchoolIcon } from './SchoolIcon';

/**
 * author: Google
 * id A671C11E-0A75-4F41-AA32-EAA99955DEDE
 * name school
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/school.svg
 * tags
 */
export const UniversityIcon = SchoolIcon;
export default UniversityIcon